module.exports = __webpack_public_path__ + "assets/img/logo_long.24c56296.svg";